import { maybeInitializeQualaroo } from 'js/qualaroo';

maybeInitializeQualaroo();
